import * as React from 'react';
import styled from 'styled-components';
import Footer from '../components/Footer';
import Header from '../components/Header';

const VideoGridStyles = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

const VideoStyles = styled.div`
  overflow: hidden;
  /* 16:9 aspect ratio */
  padding-top: 56.25%;
  position: relative;

  iframe {
    border: 0;
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
  }
`;

const SpeakingPage = () => {
  return (
    <>
      <Header />
      <main>
        <title>Speaking Page</title>
        <h1>Speaking</h1>
        <VideoGridStyles>
        <VideoStyles>
          <iframe src="https://www.youtube.com/embed/odztG_nWJQw?si=jcEXQNPIu1xOp_Qr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
          allowfullscreen></iframe>
          </VideoStyles>
          <VideoStyles>
            <iframe
              src="https://www.youtube.com/embed/ZzzG7D_0NfM"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </VideoStyles>
          <VideoStyles>
            <iframe
              src="https://www.youtube.com/embed/9dFUu0Xfrls"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            ></iframe>
          </VideoStyles>

        </VideoGridStyles>
      </main>
      <Footer />
    </>
  );
};

export default SpeakingPage;
